/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'

/* TypeScript */
export type RecommendationsApiProps = {
  technicalName?: Maybe<string>
  widgetId: string
  title?: Maybe<string>
  subtitle?: Maybe<string>
  ctaLink?: Maybe<CTALink>
}

/* Schemas */
export const RecommendationsApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  widgetId: z.string(),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  ctaLink: z.nullish(CTALinkSchema),
})

/* Schemas validation */
type TestRecommendationsApiProps = ExpectTrue<
  Equal<RecommendationsApiProps, z.infer<typeof RecommendationsApiPropsSchema>>
>
